module.exports = __webpack_public_path__ + "img/bulk-embed.41409fdb.png";